import React from "react";
import { Box, Typography } from "@mui/material";
import Header from "shared/components/Header";

const ContractPage = () => {
  return (
    <Box m="20px">
      <Header title="Contract" subtitle="Service-enabled contract module" />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Contract module is available for tenants with service code 222.
      </Typography>
    </Box>
  );
};

export default ContractPage;
